/**
 * Login/VerifyEmail Controller
 *
 * 
 */

// the constructor for this object
function LoginVerifyEmailController() { }

// the object
LoginVerifyEmailController.prototype = {
    constructor: LoginVerifyEmailController,
    
    // initialize the controller
    init: function() 
    {
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Verify Email Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // verify the email
        this._verifyEmail();
        
        PortalHelper.debugMessage('Verify Email Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the controller parameters
        this.userId = segments[0];
        this.verificationHash = segments[1];
    },
    
    // confirm that the hash and user id is valid
    _verifyEmail: function()
    {        
        var verifyEmailRequest = new PortalRequest;
        verifyEmailRequest.errorElement = '#user-profile-form .form-errors';
        verifyEmailRequest.makeRequest(
            '/users/verify-email',
            {
                userId: this.userId,
                hash: this.verificationHash
            },
            function(response) {
                PortalHelper.loadingOverlay('.verification-content', false);
                $('.verified').removeClass('hidden');
                
                setTimeout(function () {
                    window.location.href = PortalConfig.portalUrl + '/login/';
                }, 3000); 
            },
            function() {
                PortalHelper.loadingOverlay('.verification-content', false);
                $('.not-verified').removeClass('hidden');
            }
        )
    },
    
    
    
}